var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgZoomIn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 22H15C20 22 22 20 22 15V9C22 4 20 2 15 2H9C4 2 2 4 2 9V15C2 20 4 22 9 22Z",
    stroke: "#3545DE",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4545 11.4545H12.5455V8.54545C12.5455 8.23636 12.3091 8 12 8C11.6909 8 11.4545 8.23636 11.4545 8.54545V11.4545H8.54545C8.23636 11.4545 8 11.6909 8 12C8 12.3091 8.23636 12.5455 8.54545 12.5455H11.4545V15.4545C11.4545 15.7636 11.6909 16 12 16C12.3091 16 12.5455 15.7636 12.5455 15.4545V12.5455H15.4545C15.7636 12.5455 16 12.3091 16 12C16 11.6909 15.7636 11.4545 15.4545 11.4545Z",
    fill: "#3545DE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZoomIn);
export default __webpack_public_path__ + "static/media/zoomIn.2a1f7dfd90d7e0547cbd28e88f552dc5.svg";
export { ForwardRef as ReactComponent };